
import React, { useEffect, useState } from "react";

const OfflinePopup = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div style={styles.overlay} role="alertdialog" aria-modal="true">
      <div style={styles.popup}>
        <div style={styles.icon}>📡</div>

        <h2 style={styles.title}>No Internet Connection</h2>

        <p style={styles.message}>
          Your internet connection has been lost.
          Please check your network and try again.
        </p>

        <p style={styles.note}>
          This message will disappear automatically
          when your connection is restored.
        </p>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 99999,
    padding: "20px",
  },
  popup: {
    backgroundColor: "#fff",
    borderRadius: "14px",
    padding: "30px 24px",
    maxWidth: "400px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
  },
  icon: {
    fontSize: "42px",
    marginBottom: "12px",
  },
  title: {
    fontSize: "22px",
    margin: "0 0 12px",
    color: "#222",
  },
  message: {
    fontSize: "15px",
    lineHeight: 1.6,
    color: "#555",
  },
  note: {
    fontSize: "13px",
    color: "#777",
    marginBottom: 0,
  },
};

export default OfflinePopup;
